import initialState from '../store/initialState'
import questionsTypes from '../constants/questionsTypes'
import templatesTypes from '../constants/templatesTypes'

export default function pathReducer(state = initialState.currentRoute, action) {
  switch (action.type) {
    case "SET_PATH": {
      return {
        path: action.payload
      }
    }

    case questionsTypes.create.success: {
      return {
        path: 'questions'
      }
    }

    case templatesTypes.create.success: {
      return {
        path: 'templates'
      }
    }

    default: {
      return {
        ...state
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/pathReducer.js